/**
 * @desc 导出付款Tms单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.paymentMaster.exportPayRequestTmsReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/exportPayRequestTmsReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
